import { pxToRem, theme } from '@pocketlaw/tetris';
import { css } from 'styled-components';
export const suggestionStyles = css `
  .ck.ck-annotation-wrapper {
    border-radius: ${theme.borderRadius.md};

    .ck-suggestion-wrapper {
      border-radius: inherit;
      border: solid ${pxToRem(1)} ${theme.swatches.gray[50]};
      border-left: none;
    }

    .ck-thread {
      color: ${theme.semantic.foreground.primary};
      border-radius: inherit;
      background-color: inherit;
      border: solid ${pxToRem(1)} ${theme.swatches.gray[50]};
      border-left: none;
    }
  }
`;
